import React from 'react';
import { useHistory, useParams, Link } from 'react-router-dom';


function DrawingDetailContainer() {
    const history = useHistory();

    return(
        <article className="layout-contents-container page-details">
            <button type="button" className="btn-back" onClick={history.goBack}>Back</button>

            <div className="drawing-item">
                <header className="dne-info">
                    <time dateTime="" className="date">2014. 06. 24</time>
                    <span className="category">Drawing</span>
                    <h1 className="title">Title</h1>
                    <p className="copyright">
                        Choi Wook<br/>
                        Architect, Principal<br/>
                        Domus Korea - Editor & Publisher<br/>
                    </p>
                    <span className="current">1/3</span>
                </header>

                <div className="contents">
                    <ul className="list-media">
                        <li>
                            <div className="media">
                                <div className="inner">
                                    <div className="photo">
                                        <img src="https://firebasestorage.googleapis.com/v0/b/dev-architects.appspot.com/o/photos%2F-M4Dr6QG1w_FO40SewGk%2Fab523304-77a3-447b-a28d-6d391a120106.jpg?alt=media&amp;token=c3efc755-a5ed-4e5d-9359-fc449b9b5b90"/>
                                    </div>
                                </div>
                            </div>
                        </li>
                    </ul>

                    <div className="post-navigation">
                        <button type="button" className="btn-nav" onClick={history.goBack}>Back</button>
                        <Link to="#" className="btn-nav" data-disabled={false}>Next</Link>
                    </div>
                </div>
            </div>
        </article>
    );
}

export default DrawingDetailContainer;

